<template>
    <div>
        <button class="collapsible" @click="isActive = !isActive">
            {{ title }}
        </button>
        <div class="content" :class="{ active: isActive }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'collapsible',
    data() {
        return {
            isActive: false,
        };
    },
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="sass">

.collapsible
    background-color: #eee
    color: #444
    cursor: pointer
    padding: 18px
    width: 100%
    border: none
    text-align: left
    outline: none
    font-size: 15px

    &:after
        content: '\02795'
        font-size: 13px
        color: rgba(224, 81, 32, 0.8)
        float: right
        margin-left: 5px

    &.active

        &:after
            content: "\2796"

        +.content
            margin-top: 16px
            margin-bottom: 16px

    &:hover
        background-color: #ccc

.content
    padding: 0 18px
    background-color: white
    max-height: 0
    overflow: hidden
    transition: max-height 0.2s ease-out

    &.active
        max-height: 100vh
</style>
